export const REPORT_OUTPUTS = {
    DXP: {
        extension: ".pdf",
        fallback: "report.pdf",
        mime: "application/pdf",
    },
    RTF: {
        extension: ".docx",
        fallback: "report.docx",
        mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    },
    PDF: {
        extension: ".pdf",
        fallback: "report.pdf",
        mime: "application/pdf",
    },
};

export const style = (value) => {
    return REPORT_OUTPUTS[value] ?? null;
};


export const fileName = async ({
    inline,
    sanitizeFilename,
    fileName: template,
    json,
    output,
}) => {
    const outputType = style(output);

    if (!outputType) {
        throw new Error("Unsupported report output.");
    }

    let resolvedFileName = sanitizeFilename(
        await inline({
            text: template,
            json,
        })
    );

    if (!resolvedFileName) {
        resolvedFileName = outputType.fallback;
    } else if (!resolvedFileName.toLowerCase().endsWith(outputType.extension)) {
        resolvedFileName += outputType.extension;
    }

    return resolvedFileName;
};

export const generators = ({ render }) => ({
    DXP: async ({ json, uuid, output }) => {
        return await render({ json, uuid, output });
    },
    RTF: async ({ json, uuid, output }) => {
        return await render({ json, uuid, output });
    },
    PDF: async ({ json, uuid, output }) => {
        return await render({ json, uuid, output });
    },
});

export const download = ({ result, fileName, mime }) => {
    const blob = result instanceof Blob
        ? result
        : new Blob([result], mime ? { type: mime } : undefined);

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);

    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);
};